// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const READ_WHOLE_REVIEW = "\u010cti cel\u00e9...";
